import React, { Component } from "react";
import {
  Icon,
  Table,
  Grid,
  Card,
  Loader
} from "semantic-ui-react";
import "./Dashboard.css";

class Dashboard extends Component {
  state = {
    sortByCount: true,
    sortReversed: false
  };
  handleClick = site => {
    this.props.history.push({
      pathname: `/crawl-errors/${site}`,
      state: { website: site }
    });
  };

  render() {
    let table = <Loader size="large" content="Loading" active />;
    let actionItems = <Loader size="large" content="Loading" active />;

      const sortedErrors = []
        .concat(this.props.validCrawlErrors)
        .sort((a, b) => b.count - a.count);

      const sortedErrorsRev = []
        .concat(this.props.validCrawlErrors)
        .sort((a, b) => a.count - b.count);

      const sortedErrorsAlpha = []
        .concat(this.props.validCrawlErrors)
        .sort((a, b) => a.domainName.localeCompare(b.domainName));

      const sortedErrorsAlphaRev = []
        .concat(this.props.validCrawlErrors)
        .sort((a, b) => b.domainName.localeCompare(a.domainName));

      let sortType = sortedErrors;
      let isAlphaActive = ""
      let isCountActive = "isActive"

      if (!this.state.sortByCount && !this.state.sortReversed) {
        sortType = sortedErrorsAlpha;
        isAlphaActive = "isActive"
        isCountActive = ""
      } else if (!this.state.sortByCount && this.state.sortReversed) {
        sortType = sortedErrorsAlphaRev;
        isAlphaActive = "isActive"
        isCountActive = "";
      } else if (this.state.sortByCount && this.state.sortReversed) {
        sortType = sortedErrorsRev;
        isAlphaActive = ""
        isCountActive = "isActive";
      } else {
        sortType = sortedErrors;
        isAlphaActive = ""
        isCountActive = "isActive";
      }

      table = sortType.map((item, index) => {
          let isHigh = false;
          let isMed = false;
          if (item.count === 0) {
            (isHigh = false), (isMed = false);
          } else if (item.count < 10) {
            (isHigh = false), (isMed = true);
          } else if (item.count >= 10) {
            (isHigh = true), (isMed = false);
          }
          return (
            <Table.Row
              onClick={() => this.handleClick(item.siteName)}
              error={isHigh}
              warning={isMed}
              key={index}
            >
              <Table.Cell>{item.siteName}</Table.Cell>
              <Table.Cell>
                {item.count} {isHigh ? <Icon name="attention" /> : null}
              </Table.Cell>
            </Table.Row>
          );
      });

      let firstSix = sortedErrors.slice(0, 8);
      actionItems = firstSix.map((item, index) => {
          return (
            <Card
              link
              onClick={() => this.handleClick(item.siteName)}
              color="red"
              className="ActionCard"
              key={index}
            >
              <Card.Content className="siteHeader">
                      {item.siteName}
              </Card.Content>
              <Card.Content extra className="errorCount">
                <Icon name="attention" />
                {item.count} Errors
              </Card.Content>
              <Card.Content>
                  <span className="goto">
                  View Errors
                  <Icon name="arrow circle right" />
                  </span>
              </Card.Content>
            </Card>
          );
      });

    return (
      <div className="Dashboard">
          <Grid>
            <Grid.Row>
              <Grid.Column width={10}>
                <h2 className="text-center">
                  <Icon name="attention" /> Critical Websites
                </h2>
                <div className="ActionItems">{actionItems}</div>
              </Grid.Column>
              <Grid.Column width={6}>
                <div className="TableArea">
                <h2 className="text-center">
                  <Icon name="list" /> All Websites
                </h2>
                  <Table celled selectable>
                    <Table.Header>
                      <Table.Row>
                        <Table.HeaderCell
                          className={`errorHeader ${isAlphaActive}`}
                          onClick={() =>
                            this.setState({
                              sortByCount: false,
                              sortReversed: !this.state.sortReversed
                            })
                          }
                        >
                          Website
                          {this.state.sortReversed ? (
                            <Icon name="sort alphabet down" />
                          ) : (
                            <Icon name="sort alphabet up" />
                          )}
                        </Table.HeaderCell>
                        <Table.HeaderCell
                          className={`errorHeader ${isCountActive}`}
                          onClick={() =>
                            this.setState({
                              sortByCount: true,
                              sortReversed: !this.state.sortReversed
                            })
                          }
                        >
                          Error Count
                          {this.state.sortReversed ? (
                            <Icon name="sort numeric down" />
                          ) : (
                            <Icon name="sort numeric up" />
                          )}
                        </Table.HeaderCell>
                      </Table.Row>
                    </Table.Header>
                    <Table.Body>{table}</Table.Body>
                  </Table>
                </div>
              </Grid.Column>
            </Grid.Row>
          </Grid>
      </div>
    );
  }
}

export default Dashboard;



// WEBPACK FOOTER //
// ./src/components/Dashboard/Dashboard.js